import { PayloadAction } from '@reduxjs/toolkit'

import { LoadingStatusEnum } from '../../../store/types'
import { NewsItem, NewsPeriodAiAnalysis, NewsSymbol } from '../api/types'

import { StateType } from './initialState'

export const GetNewsReducer = {
  pending: (state: StateType) => ({
    ...state,
    news: {
      ...state.news,
      loading: LoadingStatusEnum.Pending,
    },
  }),
  fulfilled: (state: StateType, action: PayloadAction<NewsItem[]>) => ({
    ...state,
    news: {
      list: action.payload,
      loading: LoadingStatusEnum.Succeeded,
    },
  }),
  rejected: (state: StateType) => ({
    ...state,
    news: {
      ...state.news,
      loading: LoadingStatusEnum.Failed,
    },
  }),
}

export const GetSymbolsReducer = {
  pending: (state: StateType) => ({
    ...state,
    symbols: {
      ...state.symbols,
      loading: LoadingStatusEnum.Pending,
    },
  }),
  fulfilled: (state: StateType, action: PayloadAction<NewsSymbol[]>) => ({
    ...state,
    symbols: {
      list: action.payload,
      loading: LoadingStatusEnum.Succeeded,
    },
  }),
  rejected: (state: StateType) => ({
    ...state,
    symbols: {
      ...state.symbols,
      loading: LoadingStatusEnum.Failed,
    },
  }),
}

export const GetDailyAnalysisReducer = {
  pending: (state: StateType) => ({
    ...state,
    dailyAnalysis: {
      ...state.dailyAnalysis,
      loading: LoadingStatusEnum.Pending,
    },
  }),
  fulfilled: (state: StateType, action: PayloadAction<NewsPeriodAiAnalysis[]>) => ({
    ...state,
    dailyAnalysis: {
      list: action.payload,
      loading: LoadingStatusEnum.Succeeded,
    },
  }),
  rejected: (state: StateType) => ({
    ...state,
    dailyAnalysis: {
      ...state.dailyAnalysis,
      loading: LoadingStatusEnum.Failed,
    },
  }),
}

export const GetLast7DaysAnalysisReducer = {
  pending: (state: StateType) => ({
    ...state,
    last7DaysAnalysis: {
      ...state.last7DaysAnalysis,
      loading: LoadingStatusEnum.Pending,
    },
  }),
  fulfilled: (state: StateType, action: PayloadAction<NewsPeriodAiAnalysis[]>) => ({
    ...state,
    last7DaysAnalysis: {
      list: action.payload,
      loading: LoadingStatusEnum.Succeeded,
    },
  }),
  rejected: (state: StateType) => ({
    ...state,
    last7DaysAnalysis: {
      ...state.last7DaysAnalysis,
      loading: LoadingStatusEnum.Failed,
    },
  }),
}
